import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DeleteButton from '../../shared/DeleteButton.js';
import './BreedCardList.css';

const systemAccount = "000000000000000000000000";

const BreedCard = ({ row, onDeleted }) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const isSystem = row.account === systemAccount;

  return (
    <div className={`breed-card ${expanded ? 'expanded' : ''}`} onClick={() => setExpanded(e => !e)}>
      <div className="breed-card-main">
        <div className="breed-card-name breed-text">{row.name || '—'}</div>
        <div className={`breed-card-type ${isSystem ? 'system' : 'custom'}`}>
          {isSystem ? t('breed_type_system') : t('breed_type_custom')}
        </div>
        <div className="breed-card-chevron">{expanded ? '▲' : '▼'}</div>
        {row.matches && row.matches.length > 0 && (
          <div className="breed-card-nicknames">{Array.isArray(row.matches) ? row.matches.join(', ') : row.matches}</div>
        )}
      </div>

      {expanded && (
        <div className="breed-card-detail" onClick={e => e.stopPropagation()}>
          <div className="breed-card-detail-row">
            <span>{t('nicknames')}</span>
            <span>{Array.isArray(row.matches) ? row.matches.join(', ') : row.matches || '—'}</span>
          </div>
          <div className="breed-card-detail-row">
            <span>{t('created_by')}</span><span>{row.created_by || '—'}</span>
          </div>
          {!isSystem && (
            <div className="breed-card-actions">
              <DeleteButton
                collection="breeds"
                data={[row]}
                onComplete={onDeleted}
                onError={() => {}}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const BreedCardList = ({ data, onRefresh }) => {
  return (
    <div className="breed-card-list">
      {data && data.map(row => (
        <BreedCard key={row._id} row={row} onDeleted={onRefresh} />
      ))}
      {(!data || data.length === 0) && (
        <div className="breed-card-empty">—</div>
      )}
    </div>
  );
};

export default BreedCardList;
